import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Tax } from 'models/TaxModel';

const TaxForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.TAX, Code.Form.Name.TAX];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [formData, setFormData] = useState<Tax>({});

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
  
    API.Data.GetByKeyId<Tax>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.tax_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
      }})
      setLoading(false);
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
    });
    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
 
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Box>
                <Field.Text id={Name.Tax.Name} value={formData.tax_name} title={Title.Tax} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
                <Field.Amount id={Name.Tax.Percentage} value={formData.tax_percentage} title={Title.Percentage} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
                <Field.Area id={Name.Tax.Comment} value={formData.tax_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Box>
            </Control.Tab.Content>
 
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default TaxForm;